import type { AxiosInstance, AxiosResponse } from 'axios';
import type {
	Forms602FormSendSubmissionDto,
	Forms602FormSendSubmissionResultDto,
	Forms602FormStartSessionResultDto,
	Forms602FormSubmissionDto,
	Forms602FormSubmissionListDto,
	Forms602FormVypisKatalogDto,
} from '../generated/forms-602.types';

export interface Form602ListQueryParams {
	text?: string;
	start: number;
	pocet: number;
}

export const formCatalogQuery = async (
	axiosInstance: AxiosInstance,
	kod: string
): Promise<Forms602FormVypisKatalogDto> => {
	const { data } = await axiosInstance.get(
		'api/formulare/v1/formVypisKatalog',
		{ params: { kod } }
	);

	return data;
};

export const formRppCatalogQuery = async (
	axiosInstance: AxiosInstance,
	kod: string
): Promise<Forms602FormVypisKatalogDto> => {
	const { data } = await axiosInstance.get(
		'api/formulare/v1/formVypisKatalogRpp',
		{ params: { kod } }
	);

	return data;
};

export const formSessionQuery = async (
	axiosInstance: AxiosInstance,
	typ: string,
	formId: string,
	rezaCode?: string,
	nazev?: string
): Promise<Forms602FormStartSessionResultDto> => {
	const { data } = await axiosInstance.get(
		'api/formulare/v1/formStartSession',
		{
			params: {
				typ,
				formId,
				zastoupeni: rezaCode,
				nazev,
			},
		}
	);

	return data;
};

export const form602ListQuery = async (
	axiosInstance: AxiosInstance,
	params: Form602ListQueryParams
): Promise<Forms602FormSubmissionListDto> => {
	const { data } = await axiosInstance.get('api/formulare/v1/formSubmission', {
		params,
	});

	return data;
};

export const form602SubmissionQuery = async (
	axiosInstance: AxiosInstance,
	formularPodaniId: string
): Promise<Forms602FormSubmissionDto> => {
	const response = await axiosInstance.get(
		`api/formulare/v1/formSubmission/${formularPodaniId}`
	);

	return response.data;
};

export const form602SubmissionDeleteQuery = async ({
	formularPodaniId,
	axiosInstance,
}: {
	axiosInstance: AxiosInstance;
	formularPodaniId: string;
}) => {
	const { data } = await axiosInstance.delete(
		`api/formulare/v1/formSubmission/${formularPodaniId}/smazat`
	);

	return data;
};

export const sendForm602SubmissionQuery = async ({
	formularPodaniId,
	body,
	axiosInstance,
}: {
	formularPodaniId: string;
	body: Forms602FormSendSubmissionDto;
	axiosInstance: AxiosInstance;
}) => {
	const response =
		await axiosInstance.post<Forms602FormSendSubmissionResultDto>(
			`api/formulare/v1/formSubmission/${formularPodaniId}/odeslat`,
			body
		);

	return {
		...response.data,
		polozkaAutorizaceId: response.headers['x-autorizaceid'],
	};
};

export const downloadForm602SubmissionQuery = async ({
	id,
	axiosInstance,
}: {
	id: string;
	axiosInstance: AxiosInstance;
}): Promise<AxiosResponse<Blob>> => {
	const response = await axiosInstance.get(
		`api/formulare/v1/formSubmission/${id}/stahnout`,
		{
			responseType: 'blob',
		}
	);

	return response;
};
